import profile from "../images/profile.jpg";
import "../styles/aboutme.css";

function AboutMe() {
  return (
  	<div className="container">
  	  <div className="prof">
  	    <img className="profile" src={profile} alt="Headshot of Sonal Prasad."/>
  	  </div>
  	  <div className="text">
  	    <h3>I am a software engineer with experience in different industries, such as digital health and artificial intelligence. 
		  Proven success in optimizing machine learning pipelines, building web applications, and collaborating to reduce bottlenecks. 
		  Located in the South Bay Area.</h3>
  	  </div>
  	</div>
  );
}

export default AboutMe;